import { createNamedContext } from '@trinity/chat-components';

type FileUploadReviewStepperActions = {
  next: () => void;
};

export const FileUploadReviewStepperActionsContext = createNamedContext<FileUploadReviewStepperActions>(undefined, 'FileUploadReviewStepperActionsContext');